module.exports = __webpack_public_path__ + "img/img_zbfk.18bbc669.png";